/**
 * Promocao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {PromocaoCollection} from '@/model/collection/PromocaoCollection'

/* TODO: review generated class */
export class Promocao extends Resource {
  idPromocaoPk: number = 0

  nome: string | null = null
  urlImagem: string | null = null
  urlRedirect: string | null = null
  dataInicio: string | null = null
  dataFim: string | null = null
  dataCriacao: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idPromocaoPk
  }
  set $id(val) {
    this.idPromocaoPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of Promocao
   */
  async getPromocao(id: number) {
    return await Request.get(`/admin/promocao/${id}`)
      .name('getPromocao')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Promocao
   */
  async removePromocao() {
    return await Request.delete(`/admin/promocao/${this.$id}`)
      .name('removePromocao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Promocao
   */
  static async listPromocao(params: any) {
    return await Request.get(`/admin/promocao`, {params})
      .name('listPromocao')
      .as(PromocaoCollection)
      .getData()
  }

  /**
   * Persists a new instance of Promocao. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistPromocao() {
    return await Request.post(`/admin/promocao`, this)
      .name('persistPromocao')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Promocao to use it in a CSV file
   */
  static async listCsvPromocao(params: any) {
    return await Request.get(`/admin/promocao/csv`, {params})
      .name('listCsvPromocao')
      .as(PromocaoCollection)
      .getData()
  }
}
